'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TextAreaControl = function () {
  function TextAreaControl(element, args) {
    _classCallCheck(this, TextAreaControl);

    var div = document.createElement('div');
    this.textarea = document.createElement('textarea');
    this.textarea.id = window.PRIM.getUUID();
    this.textarea.value = args.value ? args.value : '';
    this.textarea.rows = 8;
    this.textarea.autocapitalize = 'sentences';
    this.textarea.autocorrect = 'on';
    this.textarea.spellcheck = 'true';
    this.textarea.disabled = args.readonly ? 'disabled' : '';
    this.textarea.onchange = args.onchange;
    this.label = document.createElement('label');
    this.label.innerHTML = args.label;
    this.label.htmlFor = this.textarea.id;
    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);
    div.appendChild(this.label);
    div.appendChild(this.textarea);

    element.appendChild(fragment);
  }

  _createClass(TextAreaControl, [{
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.textarea.value ? this.textarea.value : null;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.textarea.value = value;
    }
  }]);

  return TextAreaControl;
}();

exports.default = TextAreaControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/TextAreaControl.js
// module id = 69
// module chunks = 0